const imgTeamGraphic2Poster2 = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img12032 = "./assets/figma/7f2a7ce8-be0d-428a-8606-8c1344abe439.png";
const img2026923382 = "./assets/figma/221a0709-28db-4d8c-a722-6c06f1ed6284.png";
const img2026923372 = "./assets/figma/06d5533b-ffa3-4942-a40c-4910afc87dee.png";
const img2026923373 = "./assets/figma/01051303-3827-4a66-ab58-6b9c95b95078.png";
const img2026923383 = "./assets/figma/418cccde-c404-479a-9d33-5dd4ffac3b77.png";
const img2026923384 = "./assets/figma/499d08db-cdaa-42da-9329-1fa92527a224.png";
const img2026923385 = "./assets/figma/10b9af6d-7016-4cc1-bdab-56e95e2535e6.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgKakaoTalkPhoto20260915004823Jpeg1 = "./assets/figma/f33879f7-5d57-4d95-bd05-324f6d10c0ce.png";
const imgUntitled106Png1 = "./assets/figma/8f77e400-452d-42b9-b8ab-163a04215eb4.png";
const imgUntitled104Png1 = "./assets/figma/5e62b914-c473-4d20-9e13-40e2f5f783ce.png";
const imgUntitled105Png1 = "./assets/figma/3d3228f7-af75-4f1f-9cde-8f9ba2f1b36c.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/0910cb02-95b1-474b-946c-10878436c4c0.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/4089bed5-72aa-4d54-b8a7-191cd88f882f.svg";
const imgRectangle247 = "./assets/figma/0a0f13d0-9cdf-414b-9cf7-8d46976f3008.svg";
const imgClose = "./assets/figma/126d0178-fb8f-4298-97a5-6e9219784749.svg";

export default function TeamGraphic2Poster2() {
  return (
    <div className="s0 s1" data-node-id="875:2290" data-name="TEAM_GRAPHIC_2/POSTER2">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s661 s9 s10 s662" src={imgTeamGraphic2Poster2} />
        </div>
      </div>
      <div className="s2 s12 s663 s717 s15" data-node-id="875:2292" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s664 s718 s22" data-node-id="875:2293">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:2294">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2295">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2296">
            POSTERS · A2 · 4<br aria-hidden />
            GUIDE CARDS · 160 × 100 MM · 9<br aria-hidden />
            POSTCARDS · 100 × 150 MM · 8<br aria-hidden />
            <br aria-hidden />
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:2297">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:2298">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2299">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2300">
            강다원
            <br aria-hidden />
            고이룸
            <br aria-hidden />
            박성연
            <br aria-hidden />
            박세현
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s719 s54" data-node-id="875:2301">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s665 s27 s29 s720 s57" data-node-id="875:2302">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:2303">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:2304">
          <p className="s39 s40">{`그래픽 2팀은 유리관을 연결하고 조립한 타이포그래피로 DING AI LAB의 이름과 실험실이라는 공간적 특성을 시각화했다. `}</p>
          <p className="s39 s40">{`기하학적 형태와 색의 그라데이션이 겹치고 어우러지는 배경을 통해 다양한 아이디어가 모여 조화를 이루는 모습을 표현했으며, `}</p>
          <p className="s39 s40">{`텍스트를 그래픽과 연결해 활동 순서와 슬로건의 정보 위계를 정리했다. 엽서에는 서로 다른 AI의 특성과 아이디어가 변화·확장되는 과정을 `}</p>
          <p className="s39 s40">{`고유 색상, 투명 파이프와 구체로 담았다. 8가지 AI 가이드 카드에는 핵심 기능, 활용 분야, 프롬프트 예시, 사용 팁과 주의사항을 캐릭터와 `}</p>
          <p className="s39">{`색상으로  구분해 복잡한 정보를 친근하고 명확하게 전달했다.`}</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s621 s27 s29 s61 s721 s54" data-node-id="875:2305">
        GRAPHIC 2
      </p>
      <div className="s2 s623 s666 s720 s625" data-node-id="875:2306" data-name="이미지 1203 2">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12032} />
      </div>
      <p className="s23 s2 s31 s32 s63 s27 s29 s64 s722 s66" data-node-id="875:2307">
        WORK
      </p>
      <div className="s2 s16 s17 s627 s18 s36 s63 s723 s66" data-node-id="875:2308">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2309">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2310" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2311" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2312" />
          <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:2313">
            POSTER 1
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2314">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2315" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s629 s630 s9 s631 s632" src={img2026923372} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s653 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2316" />
          <div className="s80 s192 s81 s69 s633 s340 s82 s0 s70 s198 s71" data-node-id="875:2317" />
          <p className="s23 s192 s31 s94 s669 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:2318">
            POSTER 2
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2319">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2320" data-name="이미지 2026. 9. 2. 오후 3.37 3">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923373} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2321" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2322" />
          <p className="s23 s192 s31 s94 s670 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2323">
            POSTER 3
          </p>
        </div>
      </div>
      <div className="s2 s16 s17 s627 s18 s36 s63 s724 s66" data-node-id="875:2324">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2325">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2326" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s640 s9 s641 s343" src={img2026923383} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2327" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2328" />
          <p className="s23 s192 s31 s32 s671 s346 s27 s0 s198 s29 s33 s85 s672" data-node-id="875:2329">
            POSTER 4
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2330">
          <div className="s192 s69 s673 s340 s0 s70 s198 s71" data-node-id="875:2331" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s674 s675 s9 s676 s677" src={img2026923384} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2332" />
          <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:2333" />
          <p className="s23 s192 s31 s94 s678 s346 s27 s0 s198 s29 s33 s85 s679" data-node-id="875:2334">
            GUIDE CARDS
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2335">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2336" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s7 s680 s9 s10 s681" src={img2026923385} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2337" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2338" />
          <p className="s23 s192 s31 s94 s682 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2339">
            POSTCARDS
          </p>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:2340">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s683 s108 s109" data-node-id="875:2341" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:2342">
          <div className="s111 s0 s28 s112" data-node-id="875:2343" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:2348">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:2349">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:2350">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2351">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2352">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:2353">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2354">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2355">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:2356">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2357">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2358">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:2359">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:2360">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s106 s2 s67 s126 s725" data-node-id="875:1791">
        <div className="s2 s5 s726 s153 s156 s157 s725 s158" data-node-id="856:3386" />
        <p className="s23 s2 s31 s32 s727 s27 s29 s160 s728 s54" data-node-id="856:3387">
          POSTER 2
        </p>
        <div className="s106 s2 s67 s729 s730" data-node-id="856:3402">
          <div className="s106 s2 s731 s729 s165 s4 s145 s146 s730 s732" data-node-id="856:3403">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s733 s26 s734 s27 s29 s735 s736" data-node-id="856:3404">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3405">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3406">
                Prompt
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:3407">
                Premium high-resolution corporate technology visualization, vertical 3:4. A futuristic network made of clear transparent acrylic tubes with perfectly uniform diameter and wall thickness. One iridescent marble travels fully enclosed inside a tube, smaller than its inner diameter, with visible space between marble and tube wall. The network forms smooth curves, S-curves, loops, and horizontal/vertical sections as one coherent. machine. Pure white high-key lighting, subtle mint atmosphere, realistic refraction, crisp edges, soft shadows, photorealistic premium CGI, Swiss-inspired graphic design.
              </p>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3408">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3409">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:3410">
                Midjourney
              </p>
            </div>
          </div>
        </div>
        <div className="s106 s2 s67 s737 s738" data-node-id="856:3411">
          <div className="s106 s2 s739 s737 s165 s4 s145 s146 s738 s732" data-node-id="856:3412">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s740 s26 s741 s27 s29 s742 s736" data-node-id="856:3413">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3414">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3415">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34" data-node-id="856:3416">
                <p className="s175 s40">Using the first image as reference, preserve the transparent tube system, material, lighting, and overall composition. Make the central processing area the main focal point by replacing the marble with a large transparent spherical glass chamber. Inside it, place a smaller glass sphere with a delicate geometric</p>
                <p className="s175 s40">network, containing translucent mint-green and soft orange materials mixing|</p>
                <p className="s175">and transforming. Add only 1-2 smaller colored spheres in the background, without overlapping the central sphere. Keep the result clean, coherent, and photorealistic</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3417">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3418">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:3419">
                Midjourney
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s743 s189 s744 s745" data-node-id="856:3420" data-name="KakaoTalk_Photo_2026-09-15-00-48-23.jpeg 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto20260915004823Jpeg1} />
        </div>
        <div className="s2 s746 s747 s744 s748" data-node-id="856:3421" data-name="Untitled-1-06.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgUntitled106Png1} />
        </div>
        <div className="s2 s749 s227 s730 s750" data-node-id="856:3422" data-name="Untitled-1-04.png 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s751 s752 s9 s753 s754" src={imgUntitled104Png1} />
          </div>
        </div>
        <div className="s2 s755 s756 s738 s757" data-node-id="856:3423" data-name="Untitled-1-05.png 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s758 s759 s9 s760 s761" src={imgUntitled105Png1} />
          </div>
        </div>
        <p className="s23 s2 s31 s32 s715 s27 s29 s137 s762 s54" data-node-id="856:3424">
          PROCESS
        </p>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:2755" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
        <p className="s23 s31 s32 s379 s27 s0 s28 s137 s138 s380" data-node-id="875:2756">
          GRAPHIC 2
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="856:3388" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3389" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3390">
              POSTER 1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="856:3391" data-name="TAB_POSTER2">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="856:3392">
              POSTER 2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3393" data-name="TAB_POSTER3">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3394">
              POSTER 3
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3395" data-name="TAB_POSTER4">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3396">
              POSTER 4
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3397" data-name="TAB_GUIDECARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3398">
              GUIDE CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3399" data-name="TAB_POSTCARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3400">
              POSTCARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="908:213" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}